enum ChangeReason {
  CLARIFICATION_NEW_INFO = 'CLARIFICATION_NEW_INFO',
  ERROR = 'ERROR',
  DELETION = 'DELETION',
  OTHER = 'OTHER',
}

export default ChangeReason;
